<template>
    <div class="ModerationListEditor">
		<card>
			<div class="">
				<h5><i class="tim-icons icon-send text-success mr-3"></i>Добавить новый телефон в Whitelist</h5>
			</div>
			
			<div>
				<ReFormPrinter :masFormConfig="masAllFormParams" :objSaveApiMethod="currentApiFormMethod" :SuccessGo="SuccessGo" SuccessBtnText="Добавить" />
			</div>
		</card>
		<card>
			<el-table :data="ApiData" style="width: 100%;">
				<el-table-column
					label="ID"
					property="id"
					width="80"
					sortable
				></el-table-column>

				<el-table-column
					label="agent_id"
					property="agent_id"
					width="80"
				></el-table-column>

				<el-table-column 
					min-width="180"
					label="ФИО"
					property="fio"
					sortable
				></el-table-column>

				<el-table-column 
					min-width="180"
					label="Телефон"
					property="phone"
				>
					<template v-slot="scope">		
						<base-input
							v-model="scope.row.phone"
							autocomplete="off"
							type="text"
						>
						</base-input>
					</template>
				</el-table-column>	

				<el-table-column 
					min-width="180"
					label="Примечание"
					property="description"
				>
					<template v-slot="scope">		
						<textarea
							class="form-control"
							v-model="scope.row.description"
							autocomplete="off"
							type="text"
						>
						</textarea>
					</template>
				</el-table-column>		

				<el-table-column
						width="80"
						label=""
					>
					<template v-slot="scope">			
						<el-button class="no-border my-0">
							<button class="ml-3 btn btn-icon btn-simple btn-success" @click="UpdateList(scope.row)">
								<i class="tim-icons icon-book-bookmark"></i>
							</button>											
						</el-button>
					</template>
				</el-table-column>
			
			<el-table-column
					width="120"
					label="Действие"
					align="right"                    	
			>
				<template v-slot="scope">		
					<ReActionBtns :masActions="masActions[scope.$index]"/>
					<!-- <el-tooltip content="Удалить" placement="top">
						<el-button class="no-border my-0">
							<button class="ml-3 btn btn-icon btn-simple btn-danger" disabled @click="DeleteRow(scope.row)">
								<i class="tim-icons icon-trash-simple"></i>
							</button>											
						</el-button>
					</el-tooltip>							 -->
				</template>
			</el-table-column>			
			</el-table>
			<Pagination class="mt-3" :class="[{'': parseInt(masObjects_total) > 0}, {'d-none': parseInt(masObjects_total) < 1}]"
				:type="'info'" 
				:total="parseInt(masObjects_total)*parseInt(count2page)" 
				:perPage="parseInt(count2page)"
				:value="parseInt(typeof objGetParams.p == 'undefined' ? 1:objGetParams.p)"
				:pClick="pClick">
			</Pagination>
		</card>
    </div>
</template>
<script>

// import {eventEmitter} from "src/plugins/globalComponents.js";
import { Table, TableColumn,  Select, Option, Tooltip, Button } from 'element-ui';
// import { BaseSwitch } from 'src/components/index';
// import ReFilterBtn from 'src/our_components/FilterPrinter/ReFilterBtn.vue';
// import ReFilter from 'src/our_components/FilterPrinter/ReFilter.vue';
import ReFormPrinter from "src/our_components/FormPrinter/ReFormPrinter.vue";
import Pagination from 'src/our_components/RePagination';
import ReActionBtns from 'src/our_components/ReActionBtns.vue';

export default {
	name: 'phone_whitelist_editor-page',
	components: {
	    [Table.name]: Table,
    	[TableColumn.name]: TableColumn,
        [Option.name]: Option,
        [Select.name]: Select,
        [Tooltip.name]: Tooltip,
          [Button.name]: Button,
		// BaseSwitch,
		// ReFilterBtn,
        // ReFilter,
        ReFormPrinter,
        Pagination,
		ReActionBtns,

	},
	data() {
		return {
			ApiData: [],
			masAllFormParams: this.currentFormConfig(),
			currentApiFormMethod: this.currentApiFormMethodComp(),
			objGetParams:{},
			masObjects_total: 0,
			count2page: 10,
			masActions:[],	
			masCheckGroupOpts:[{value:1, label:'Описание'},{value:2, label:'Фото'},{value:3, label:'Дополнительные характеристики'},{value:4, label:'Примечание'},],
			// saveToServName:'',
		};
	},
	methods: {
		getApiData(){
			this.$GVO.ApiCall('PHONE_WHITELIST.GET',{flt:{'id':'true','c2p':50}} )
			.then((objApi) => {
				if(objApi.success === true){
					if(objApi.data.length > 0){
						this.ApiData = objApi.data;
						this.masObjects_total = objApi.countpage;

						this.masActions = [];
						for (let i = 0; i < this.ApiData.length; i++) {
							this.masActions.push([
								{
									actionType: 'switcher',
									label_on: 'Вкл',
									label_off: 'Выкл',
									action_model: this.ApiData[i].act=='1'?true:false,						
									onClickApi: {apiMethod: 'CHANGE_ACT',apiParam:{obj:'PHONE_WHITELIST',flt:{id:this.ApiData[i].id}}},
								},
								// {
								// 	actionType: 'btn_save',
								
								// 	// action_model: this.ApiData[i].act=='1'?true:false,						
								// 	onClickApi: {apiMethod: 'UPD',apiParam:{obj:'PHONE_WHITELIST',flt:{id:this.ApiData[i].id},name:this.ApiData[i].name},},
								// },
								// {
								// 	actionType: 'btn_del',
								// 	onClickApi: {apiMethod:'DEL',apiParam:{obj:'BP_CHECKLIST',flt:{id:this.ApiData[i].id}}},
								// },
							]);							
						}
					}else{
						this.ApiData = [];
						this.masObjects_total=0;
					}
				}else{
					this.ApiData = [];
					this.masObjects_total=0;
				}
			}).catch(errorObjApi => {this.ApiData = []; this.masObjects_total=0; console.error(errorObjApi);});
		},
		currentFormConfig() {
			this.$GVO.ApiCall('PHONE_WHITELIST.GET_FORM_MODEL',{})
				.then((objApi) => {
					if(objApi.success){
						this.masAllFormParams = objApi.config;
					}
				})
				.catch(errorObjApi => console.error(errorObjApi));
			return [];
		},
		currentApiFormMethodComp(){
            return {apiMethod:'PHONE_WHITELIST.INS',apiParam:{iData:[]}};
        },
		SuccessGo(evt,dopParam){
	        this.masAllFormParams = this.currentFormConfig();
			this.getApiData();
		},		
		// DeleteRow(row){
		// 	if(row.id != null){
		// 		this.$GVO.ApiCall('BP_CHECKLIST.DEL',{ flt:{id: row.id}}) 
		// 			.then((objApi) => {
		// 				if(objApi.success === true){
		// 					this.getApiData();
		// 				}else{
		// 					alert('Не удалилось');
		// 				}
		// 			}).catch(errorObjApi => {console.log(errorObjApi);});
		// 	}
		// },
		pClick(e){
			this.objGetParams['p'] = parseInt(e);
			// this.OnFilterApply();
		},
		UpdateList(row){
			if(row.id != null){
				this.$GVO.ApiCall('PHONE_WHITELIST.UPD',{ flt:{id: row.id},uData:{
					'description': row.description, 
					'act': row.act,
					'phone': row.phone,
					'fio': row.fio,
					'agent_id': row.agent_id,
					}}).then((objApi) => {
						//console.log(objApi);
						if(objApi.success === true){
							this.getApiData();
							this.openFullScreen1();
						}else{
							alert('Не сохранилось');
						}
					}).catch(errorObjApi => {console.error(errorObjApi);});
			}
		}, 
		// GoEdit(row){
		// 	if(row.id != null){
		// 		this.$router.push({path: this.$GVO.str_replace('/helpdesk','/helpdeskstaff',location.pathname)+'/'+row.id});
		// 	}
		// }
	},		
	mounted() {
		this.getApiData();
	}
};
</script>
<style>
.ModerationListEditor .bntGroup {
	display: flex;
	justify-content: flex-start;
}
.ModerationListEditor .form-options-group{
	flex-direction: row;
	width: 100%;
	align-items: center;
	flex-wrap: wrap;
}
.ModerationListEditor .form-options-group > div{
	margin-right: 5px;
}
.ModerationListEditor .form-group {
	margin-bottom: 0px!important;
}
.ModerationListEditor-table .cell {
	word-break: break-word!important;
}
.ModerationListEditor .el-table tr:hover {
    background: rgb(1, 176, 224, 0.33);
}


</style>
